"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContext = void 0;
exports.UserProvider = UserProvider;
var react_1 = __importStar(require("react"));
var api_1 = require("../api");
exports.UserContext = (0, react_1.createContext)({
    userinfo: {},
    userLogin: function (username, password) { },
    userLogout: function () { },
});
function UserProvider(_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)({}), userinfo = _b[0], setUserinfo = _b[1];
    (0, react_1.useEffect)(function () {
        (0, api_1.getUserinfo)().then(function (uinfo) {
            if (uinfo) {
                setUserinfo(uinfo);
            }
        });
    }, []);
    function userLogin(username, password) {
        (0, api_1.login)(username, password).then(function (uinfo) {
            if (uinfo) {
                setUserinfo(uinfo);
            }
        });
    }
    function userLogout() {
        (0, api_1.logout)().catch(console.error);
        setUserinfo({});
    }
    var userValue = {
        userinfo: userinfo,
        userLogin: userLogin,
        userLogout: userLogout,
    };
    return react_1.default.createElement(exports.UserContext, { value: userValue }, children);
}
